import { render } from "./BusinessCard.vue?vue&type=template&id=4ffeb162&scoped=true"
import script from "./BusinessCard.vue?vue&type=script&lang=js"
export * from "./BusinessCard.vue?vue&type=script&lang=js"

import "./BusinessCard.vue?vue&type=style&index=0&id=4ffeb162&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffeb162"]])

export default __exports__